import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { useRef } from "react";
import Quill from "react-quill";
interface Props {
  data: string;
  onChange: (data: string) => void;
  disabled?: boolean;
  error?: boolean;
  heightContent?: string;
  placeHolder?: string;
}
const ContentComponent = ({
  data,
  onChange,
  disabled = false,
  error = false,
  heightContent = "300px",
  placeHolder = "",
}: Props) => {
  const quillRef = useRef<any>(null);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "blockquote"],
      [
        { align: [] },
        // { align: "center" },
        // { align: "right" },
        // { align: "justify" },
      ],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      // [{ size: [] }],
      ["link"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "align",
    "color",
    "background",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  function handleChangeInput(content: string) {
    onChange(content);
  }

  return (
    <EditorWrapper
      className={`overflow-auto ${error ? "border-danger" : "border-full"}`}
      minHeight={heightContent}
    >
      <Quill
        placeholder={placeHolder}
        readOnly={disabled}
        style={{
          minHeight: heightContent,
          pointerEvents: disabled ? "none" : "auto",
          opacity: disabled ? 0.5 : 1
        }}
        className="quill-custom"
        ref={quillRef}
        modules={modules}
        formats={formats}
        value={data || ""}
        onChange={handleChangeInput}
        theme="snow"
      />
    </EditorWrapper>
  );
};

const EditorWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "minHeight",
})(({ minHeight }: any) => ({
  ".quill-custom": {
    ".ql-editor": {
      minHeight: minHeight,
    },
  },
}));
export default ContentComponent;
